import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { Mail, Phone, MapPin, Send } from 'lucide-react';


export const FAQ = () => {
  const faqs = [
    {
      question: 'What is Mahasarathi?',
      answer: 'Mahasarathi is a unified mobility platform designed to integrate buses, metros, trains, autos and cabs on a single interoperable layer. we\'re building the core infrastructure to enable seamless multi-modal journey planning.'
    },
    {
      question: 'What stage is Mahasarathi at?',
      answer: 'We\'re currently in R&D phase with active partnerships with state RTCs, city transport operators and mobility agencies. Beta testing with select operators is planned soon.'
    },
    {
      question: 'What\'s your business model?',
      answer: 'Multi-stream revenue: B2B SaaS APIs for operators (₹10-50K/month), consumer app freemium model, IoT hardware sales for real-time tracking and contextual advertising partnerships.'
    },
    {
      question: 'How is Mahasarathi different from existing apps?',
      answer: 'We\'re not a ride-hailing service. We\'re building a neutral, interoperable platform layer that connects ALL transport modes fairly - not competing with operators but enabling them to work together.'
    },
    {
      question: 'What problem does Mahasarathi solve?',
      answer: 'Today, commuters use 5+ apps, get inaccurate ETAs, miss connections and have no unified payment. Cities lose ₹22B+ annually to congestion due to fragmented transport systems.'
    },
    {
      question: 'Are you taking investment?',
      answer: 'Yes, we\'re actively seeking mission-driven investors, impact funds and government partnerships to scale operations. Early-stage funding discussions are ongoing.'
    },
    {
      question: 'How can I support Mahasarathi or get early access?',
      answer: 'If you\'re an operator, agency, investor or early adopter interested in partnering, reach out to hello.mahasarathi@gmail.com or sign up for early access on our website. We welcome collaboration and feedback from our community.'
    },

    // {
    //   question: 'Which cities are covered?',
    //   answer: 'Phase 1: Hyderabad & Telangana RTC network. Phase 2 expansion: Bengaluru, Delhi-NCR, Mumbai, Chennai, Kolkata, and 10+ Tier-1 cities by Q3 2026.'
    // },
    {
      question: 'Can I book tickets for trains and flights?',
      answer: 'Yes! Unified booking across State Transport buses, IRCTC trains, Domestic flights, Uber/Ola cabs and metro rail. All from one app with single payment.'
    },
    // {
    //   question: 'How accurate are the ETAs?',
    //   answer: '95%+ accuracy through GPS telemetry from 5,000+ buses, real-time traffic data, historical patterns and ML predictions. Weather and roadworks factored automatically.'
    // },
    {
      question: 'Is my payment information safe?',
      answer: 'Bank-grade PCI DSS Level 1 compliance. We use tokenization - never store full card details. All transactions via Razorpay/PayU with 2FA protection.'
    },
    {
      question: 'What if I miss my connection?',
      answer: 'Live tracking monitors your entire journey. Automatic re-routing suggestions if delays detected. One-tap rebooking for next available connection.'
    },
    {
      question: 'How does multi-modal planning work?',
      answer: 'AI analyzes 1000s of combinations across transport modes to optimize for your priority (fastest, cheapest, fewest transfers, least walking). Shows cost/time comparison.'
    },
    {
      question: 'For operators: How do I integrate?',
      answer: 'Simple REST APIs for GTFS-RT feeds, booking, payments. No vendor lock-in. White-label apps available. Contact integrations@mahasarathi.in for sandbox access.'
    },
    {
      question: 'What payment methods are supported?',
      answer: 'UPI (PhonePe, GPay, Paytm), Credit/Debit cards, Net banking, Wallets. Unified wallet across all bookings. No convenience fee on UPI.'
    },
    
    {
      question: 'Why focus on public transport integration?',
      answer: 'Public transport is the backbone of India\'s mobility but suffers from fragmentation across jurisdictions and operators. By creating a unified layer, we can serve millions of daily commuters and reduce urban congestion.'
    },
    {
      question: 'What about smaller cities and rural areas?',
      answer: 'Rural connectivity is part of our long-term vision. We\'re designing the platform to scale from metros to tier-3 towns, supporting informal transport like shared jeeps and e-autos alongside formal systems.'
    },
    {
      question: 'How will you ensure data privacy?',
      answer: 'Data privacy is foundational. We\'re building with GDPR-aligned practices, local data residency, and transparent user controls. No data sharing with third parties without explicit consent.'
    },
    
    {
      question: 'Can government agencies use this?',
      answer: 'Yes. We\'re building for governments and city authorities to use our APIs for traffic management, congestion analysis, and urban mobility planning. Government adoption is key to our model.'
    },
    {
      question: 'What\'s your approach to affordability?',
      answer: 'We believe mobility is essential infrastructure. Consumer app will be free with optional premium features. B2B pricing is designed to be affordable for RTCs and small operators, not just large corporations.'
    },
    {
      question: 'How do you handle payment across different operators?',
      answer: 'Our unified wallet integrates with UPI, cards and wallets. Single payment covers multi-operator journeys. We handle settlement backend so operators receive payments directly.'
    },
    // {
    //   question: 'What\'s your timeline for national expansion?',
    //   answer: 'Hyderabad pilot (2026), expansion to 5-10 cities (2026-2027), national presence (2027-2028). Speed depends on operator partnerships and funding. We\'re playing the long game.'
    // },
    {
      question: 'How will you compete with Google Maps and Citymobility?',
      answer: 'Google Maps shows routes but can\'t book. CityMobility is city-specific. We\'re building the first truly unified, interoperable layer across ALL cities and ALL modes. We\'re complementary to navigation apps, not competing.'
    },
    {
      question: 'What happens if an operator doesn\'t want to join?',
      answer: 'No operator is forced. We\'re building a voluntary, opt-in network. As more operators join and get more ridership, others naturally want in. Network effects work in our favor.'
    },
    {
      question: 'How do you handle technical challenges like real-time data sync?',
      answer: 'We\'re architecting for resilience from day one. Redundant systems, offline-first design, local caching and graceful degradation ensure the platform works even with poor connectivity.'
    },
    {
      question: 'What\'s your go-to-market strategy?',
      answer: 'B2B first - partner with RTCs, prove the model, then launch consumer app. Governments and operators are our primary stakeholders. Consumer adoption follows naturally once infrastructure is live.'
    },
    {
      question: 'Who are your advisors and partners?',
      answer: 'We\'re collaborating with government mobility agencies, open-source platforms, academic institutions and experienced advisors from transport and tech sectors.'
    },
    {
      question: 'What\'s your stance on informal transport?',
      answer: 'Informal transport (shared jeeps, autos, e-autos) carries 30%+ of commutes in India. We\'re designing the platform to include and formalize them, not exclude them.'
    },
    {
      question: 'How do you ensure operator independence?',
      answer: 'No lock-in. Operators own their data. They can integrate with us via APIs but retain full control of pricing, routes and branding. We\'re a platform, not a controller.'
    },
    {
      question: 'What\'s the social impact you\'re targeting?',
      answer: 'Reduce commute time (saves 2+ hours/week per person), cut congestion (₹22B+ savings), improve air quality, enable job access and provide 50M+ Indians with better mobility options.'
    },
    

  ];

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[#1B4F72] to-[#138808] text-white py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl font-bold mb-6">Frequently Asked Questions</h1>
          <p className="text-xl text-gray-100 max-w-2xl mx-auto leading-relaxed">
            Everything you need to know about India's unified mobility platform
          </p>
        </div>
      </section>

      {/* FAQs */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 -mt-10">
        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`} className="bg-white rounded-2xl shadow-lg border-0 overflow-hidden">
                <AccordionTrigger className="px-8 py-6 text-left hover:no-underline h-auto data-[state=open]:bg-gray-50">
                  <h3 className="text-xl font-semibold text-[#1B4F72]">{faq.question}</h3>
                </AccordionTrigger>
                <AccordionContent className="px-8 pb-8 text-gray-600 leading-relaxed text-lg">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          {/* Quick Contact */}
          <div className="mt-16 p-8 bg-gradient-to-r from-[#FF9933] to-[#E68A2E] rounded-2xl text-white text-center">
            <h3 className="text-2xl font-bold mb-4">Still have questions?</h3>
            <p className="text-lg mb-6 opacity-90">Our support team responds within 30 minutes</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center text-lg font-semibold">
              <a href="mailto:support@mahasarathi.in" className="flex items-center gap-2 hover:scale-105 transition-transform">
                <Mail className="w-5 h-5" />
                hello.mahasarathi@gmail.com
              </a>
              <a href="tel:+918888888888" className="flex items-center gap-2 hover:scale-105 transition-transform">
                <Phone className="w-5 h-5" />
                
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
